var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edu-layout',{attrs:{"type":"table"}},[_c('a-tabs',{attrs:{"slot":"table"},slot:"table"},[_c('a-tab-pane',{key:"1",attrs:{"tab":"预算统计"}},[_c('fundCount')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"报销统计"}},[_c('claimCount')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }